import { render, staticRenderFns } from "./color-saturation-slider.vue?vue&type=template&id=aef44dea"
import script from "./color-saturation-slider.vue?vue&type=script&lang=js"
export * from "./color-saturation-slider.vue?vue&type=script&lang=js"
import style0 from "./color-saturation-slider.vue?vue&type=style&index=0&id=aef44dea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports